import * as PIXI from "pixi.js"
import { app } from "./appPixi.js";
import { config, isPixiStandAlone, path as basePath, gameDisplaySettings } from "./settings.js";
import { AnimationSprite, ObjectPool, countCharacters, getDirection, splitGradientTexture, spriteSettings, updateBallRow } from "./utility.js";
import { distance } from "./gameLogic.js";
import {
  boxColor,
  boxNumbers,
} from "./bridge.js";
import { DEFAULT_PLINKO_PINS } from "../plinkogame.constants.js";

let ballPool;
let pegs = [];
let pegsForShine = [];
let balls = [];
let boxes = [];
let path = [];
let totalBalls = 0;
let uiCreated = false;
let boolBallCreated = false;
let isSetupBoxes = false;
let totalLines = isPixiStandAlone ? 16 : DEFAULT_PLINKO_PINS;
export let bgDestroyed = false;
let bgCreated = false;

let pegHolder;

const fonts = {
  Staatliches: {}
}

const gameAssets = {
  background: {
    left: {
      one: new PIXI.Sprite(),
      two: new PIXI.Sprite(),
      three: new PIXI.Sprite(),
      four: new PIXI.Sprite(),
    },
    right: {
      one: new PIXI.Sprite(),
      two: new PIXI.Sprite(),
      three: new PIXI.Sprite(),
      four: new PIXI.Sprite(),
    },
  },
  //Fonts
  fonts: {
    regular: {},
  },
};

let pegsInRows = Array.from(
  { length: totalLines },
  (_, rowIndex) => rowIndex + config.pinInFirstLine
);
const containers = {
  rootContainer: new PIXI.Container(),
  bgContainer: null,
  pegsContainer: null,
  ballContainer: [],
  lightningContainer: new PIXI.Container(),
};

function createUI () {
  prepareContainers();
  createPegsHolder();
  createPegs(config.pegs);
  setupBoxes();
  createBallsPool()
  uiCreated = true;
}
function createPegsHolder () {
  pegHolder = new PIXI.Sprite(PIXI.Assets.get('sqBG'));
  pegHolder.x = gameDisplaySettings.x;
  pegHolder.y = gameDisplaySettings.y;
  pegHolder.anchor.set(0.5);
  pegHolder.width = gameDisplaySettings.size;
  pegHolder.height = pegHolder.width;
  pegHolder.sortableChildren = true;

  containers.rootContainer.addChild(pegHolder);
}

function prepareContainers () {
  app.stage.addChild(containers.rootContainer);
  containers.rootContainer.name = "RootContainer";
  containers.ballContainer.name = "BallContainer";
  containers.rootContainer.position.set(0, 80);
}

function createPegs (pegConfig) {
  let pegNo = 0;
  for (let row = 0; row < totalLines; row++) {
    const numPegs = pegsInRows[row];
    const singleRowPegsContainer = new PIXI.Container();
    let currentPeg = [];
    for (let i = 0; i < numPegs; i++) {
      const peg = {};

      peg.sprite = new PIXI.Sprite(PIXI.Assets.get("pin"));
      peg.sprite.width = config.pegs.pegsWidth + (16 - totalLines) * 5;
      peg.sprite.height = config.pegs.pegsWidth + (16 - totalLines) * 5;
      peg.sprite.anchor.set(0.5);
      peg.sprite.x =
        (i - (numPegs - 1) / 2) *
        ((config.pegs.spacing.width * 16) / totalLines);
      if (row == 0)
        peg.sprite.y =
          row * ((config.pegs.spacing.height * 16) / totalLines) -
          config.topMargin;
      else
        peg.sprite.y =
          (row * (config.pegs.spacing.height - totalLines * 0.45) * 16) /
          totalLines -
          config.topMargin;

      pegNo++;

      peg.states = [];
      peg.shine = new PIXI.AnimatedSprite(
        PIXI.Assets.get("shineEffect").animations.frames
      );
      peg.shine.scale.set(3.5);  // 1
      peg.shine.alpha = 0.3   // 0.55
      peg.shine.animationSpeed = config.pegs.shine.animationSpeed; //0.7
      peg.shine.visible = false;
      peg.startShine = () => {
        peg.shine.play();
        peg.shine.visible = true;
      };
      peg.shine.onLoop = () => {
        peg.shine.gotoAndStop(1);
        peg.shine.visible = false;
      };

      peg.shine.anchor.set(0.5);
      peg.sprite.addChild(peg.shine);

      singleRowPegsContainer.addChild(peg.sprite);
      pegs.push(peg);
      currentPeg.push(peg);
    }
    pegsForShine.push(currentPeg);
    currentPeg = [];
    pegHolder.addChild(singleRowPegsContainer);
  }

}

// let ballScaleForAnimation = 1.9
const globalPoint = new PIXI.Point(0, 0);

function createBallsPool () {
  ballPool = new ObjectPool(() => new AnimationSprite(pegHolder, pegs[0].sprite.y), 50)
}

function animatedBallCreate (testPathAnim, lastBall = false, winAmt) {
  let animatedBallSprite = ballPool.getObject();
  animatedBallSprite.setVisiblity(true)
  animatedBallSprite.animationSprite.scale.set(
    getDirection(testPathAnim, 0) * config.ball.scaleForAnimation[totalLines - 8],
    config.ball.scaleForAnimation[totalLines - 8]
  );
  animatedBallSprite.animationSprite.drop = animatedBallSprite.moveBall;
  animatedBallSprite.animationSprite.onLoop = () => animatedBallSprite.onLoop(testPathAnim);
  animatedBallSprite.animationSprite.lastBall = lastBall
  animatedBallSprite.animationSprite.winAmt = winAmt

  balls.push(animatedBallSprite.animationSprite);
}

function createBall (lastBall = true, winAmt) {
  totalBalls++;
  animatedBallCreate(path[totalBalls - 1], lastBall, winAmt)
}

function setupBoxes () {
  const colorsPannel = [
    ['red', 'orange', 'yellow', 'yellow', 'grey', 'yellow', 'yellow', 'orange', 'red'],
    ['red', 'orange', 'yellow', 'yellow', 'grey', 'grey', 'yellow', 'yellow', 'orange', 'red'],
    ['red', 'orange', 'orange', 'yellow', 'yellow', 'grey', 'yellow', 'yellow', 'orange', 'orange', 'red'],
    ['red', 'orange', 'orange', 'yellow', 'yellow', 'grey', 'grey', 'yellow', 'yellow', 'orange', 'orange', 'red'],
    ['red', 'red', 'orange', 'orange', 'yellow', 'yellow', 'grey', 'yellow', 'yellow', 'orange', 'orange', 'red', 'red'],
    ['red', 'red', 'orange', 'orange', 'yellow', 'yellow', 'grey', 'grey', 'yellow', 'yellow', 'orange', 'orange', 'red', 'red'],
    ['red', 'red', 'red', 'orange', 'orange', 'yellow', 'yellow', 'grey', 'yellow', 'yellow', 'orange', 'orange', 'red', 'red', 'red'],
    ['red', 'red', 'red', 'red', 'orange', 'orange', 'yellow', 'grey', 'grey', 'yellow', 'orange', 'orange', 'red', 'red', 'red', 'red'],
    ['red', 'red', 'red', 'red', 'orange', 'orange', 'yellow', 'yellow', 'grey', 'yellow', 'yellow', 'orange', 'orange', 'red', 'red', 'red', 'red'],
  ];

  const boxTextures = {
    grey: PIXI.Assets.get('pinAndBox').textures.grey,
    yellow: PIXI.Assets.get('pinAndBox').textures.yellow,
    orange: PIXI.Assets.get('pinAndBox').textures.orange,
    red: PIXI.Assets.get('pinAndBox').textures.red,

  }

  const widthOffset = [0, 17, 32, 44, 54, 62, 68, 74, 80]
  const boxScale = 1.2;

  let boxHeight = config.box.height + 10 - totalLines * config.box.heightScale
  let boxWidth = config.box.width - widthOffset[totalLines - 8]

  const gradientSprites = splitGradientTexture(pegsInRows[totalLines - 1] - 1)
  for (let box = 0; box < gradientSprites.length; box++) {
    const boxContainer = new PIXI.Container()
    pegHolder.addChild(boxContainer)
    boxContainer.zIndex = 1;



    let sprite = new PIXI.Sprite(PIXI.Assets.get('pinAndBox').textures.grey);
    sprite.texture = boxTextures[colorsPannel[totalLines - 8][box]]
    sprite.width = boxWidth
    sprite.height = boxHeight

    const maskGraphics = new PIXI.Graphics()
    maskGraphics.beginFill(0xffffff, 0)
    maskGraphics.drawRoundedRect(-sprite.width / 2, -sprite.height / 2, sprite.width, sprite.height, config.box.cornerEdgeRadius)
    maskGraphics.endFill()

    boxContainer.addChild(maskGraphics, sprite);

    sprite.anchor.set(0.5)
    boxContainer.x = (box - (pegsInRows[totalLines - 1] - 2) / 2) * (config.pegs.spacing.width * 16 / totalLines);
    boxContainer.y = boxContainer.startPos = config.topMargin;
    boxes.push({ sprite: boxContainer });
    sprite.boxColor = box.white
    sprite.boxState = sprite.doNothing

    boxContainer.doNothing = () => { };
    boxContainer.states = [];

    boxContainer.BoxBounceEffect = (delta) => {
      if (boxContainer.y > boxContainer.startPos) {
        boxContainer.y -= delta * config.box.boxSpeed
      } else {
        boxContainer.y = boxContainer.startPos
        boxContainer.boxState = boxContainer.doNothing
      }
    };

    boxContainer.boxBounceEffectState = boxContainer.BoxBounceEffect;

    boxContainer.states.push(boxContainer.boxBounceEffectState);

    let textX = new PIXI.Text(
      "x",
      new PIXI.TextStyle({
        fill: 0xffffff,
        fontSize: 20,
        fontWeight: "800",

      })
    );
    textX.anchor.set(0.66);
    textX.y = 4

    let text = new PIXI.Text(
      "0.0",
      new PIXI.TextStyle({
        fill: 0xffffff,
        fontSize: 29,
        fontWeight: "800",

      })
    );
    text.anchor.set(0.56);

    boxContainer.addChild(text, textX);
    isSetupBoxes = true;
  }
}

function startMovingBall (ballPath) {
  path.push([...ballPath]);
}

function setupPayoutText (payout) {
  let max = 0
  let scale = 0
  for (let i = 0; i < boxes.length; i++) {

    if (payout[i] || payout[i] === 0) {
      const multiplierText = boxes[i].sprite.children[2]
      multiplierText.text = payout[i];
      boxes[i].sprite.children[3].x = boxes[i].sprite.children[2].width * 0.5 + boxes[i].sprite.children[3].width * 0.5

      if (max < multiplierText.width) {
        max = multiplierText.width
      }
    }
    else console.error("Sent payout is not a valid number");
  }
  for (let i = 0; i < boxes.length; i++) {
    const multiplierText = boxes[i].sprite.children[2]
    const length = countCharacters(multiplierText.text)
    const number = Number(multiplierText.text)

    if (multiplierText.text.includes('1K')) {
      boxes[i].sprite.children[3].visible = false
    }
    else if (number > 99) {
      boxes[i].sprite.children[3].visible = false
    } else {
      boxes[i].sprite.children[3].visible = true
    }

  }

  boxes.forEach((box) => {
    const maskGraphics = box.sprite.children[0]
    const sprite = box.sprite.children[1]

  })
}

function changeNumberOfLines (reqLines) {
  isSetupBoxes = false;
  totalLines = reqLines;

  function destroyBgContianer () {
    pegHolder.destroy({
      children: true,
    });
  }
  function createpinsContainer () {
    resetUI();
  }
  function resetValues () {
    containers.ballContainer = [];
    pegs = [];
    boxes = [];
    pegsForShine = [];
    pegsInRows = Array.from(
      { length: totalLines },
      (_, rowIndex) => rowIndex + config.pinInFirstLine
    );
  }
  bgDestroyed = true;
  destroyBgContianer();
  resetValues();
  createpinsContainer();
}

function clearAllBalls () {
  totalBalls = 0;
  containers.ballContainer.forEach((ballContainer) => {
    ballContainer.destroyBall();
  });

  path = [];
}

function scaleFactor () {
  return (config.maxLines + 16) / (totalLines + 16);
}

function gameScaling () {
  let rhs = 1.4 - Math.floor((totalLines - 8) / 2) * 0.1;
  rhs = rhs.toFixed(1);
  containers.rootContainer.scale.set(scaleFactor() * rhs);
}

function boxBounceEffect (index) {
  const box = boxes[index];

  if (!box) return;
  box.sprite.y += 40;  // box.sprite.startPos;
  box.sprite.boxBounceEffectState = box.sprite.BoxBounceEffect;
}

function lightningModeUI (lightData) {
  // normalModeUI();

  // setupScullBoxes(true);

  // lightData.forEach((pin) => {
  //   let row = pin.position[0] - 1;
  //   let column = pin.position[1] - 1;

  //   let targetPin = gameAssets.pins[row][column];
  //   targetPin.tint = boxColor.pink;
  //   targetPin.children[0].text = pin.multiplier;

  //   targetPin.hilighted = true;
  // });

  // Object.keys(gameAssets.background.left).forEach((asset) => {
  //   gameAssets.background.left[asset].targetPosition.x =
  //     gameAssets.background.left[asset].destination.x;
  //   gameAssets.background.left[asset].targetPosition.y =
  //     gameAssets.background.left[asset].destination.y;
  // });
  // Object.keys(gameAssets.background.right).forEach((asset) => {
  //   gameAssets.background.right[asset].targetPosition.x =
  //     gameAssets.background.right[asset].destination.x;
  //   gameAssets.background.right[asset].targetPosition.y =
  //     gameAssets.background.right[asset].destination.y;
  // });
}

function removeLightningMode () {
  // normalModeUI();
  // setupScullBoxes(false);

  // Object.keys(gameAssets.background.left).forEach((asset) => {
  //   gameAssets.background.left[asset].targetPosition.x =
  //     gameAssets.background.left[asset].initialPosition.x;
  //   gameAssets.background.left[asset].targetPosition.y =
  //     gameAssets.background.left[asset].initialPosition.y;
  // });
  // Object.keys(gameAssets.background.right).forEach((asset) => {
  //   gameAssets.background.right[asset].targetPosition.x =
  //     gameAssets.background.right[asset].initialPosition.x;
  //   gameAssets.background.right[asset].targetPosition.y =
  //     gameAssets.background.right[asset].initialPosition.y;
  // });
}

function normalModeUI () {
  pegs.forEach((p) => {
    p.sprite.tint = boxColor.white;
  });
}

function setupScullBoxes (isScull) {
  // if (gameAssets.boxes[6]) setupScull(6)
  // if (gameAssets.boxes[8]) setupScull(8)
  // if (gameAssets.boxes[10]) setupScull(10)
  // function setupScull(boxIndex) {
  //   // texture
  //   gameAssets.boxes[boxIndex].texture = isScull ?
  //     PIXI.Assets.get('lightning').textures.boxBlack :
  //     PIXI.Assets.get('plinko').textures.box
  //   // tint
  //   //gameAssets.boxes[boxIndex].tint = isScull ? boxColor.white : gameAssets.boxes[boxIndex].boxColor
  //   gameAssets.boxes[boxIndex].tint = "0xFFFFFF"
  //   // text
  //   gameAssets.boxes[boxIndex].children[0].visible = isScull ? false : true
  //   //scalling
  //   if (isScull) {
  //     gameAssets.boxes[boxIndex].scale.set(0.77)
  //   } else {
  //     gameAssets.boxes[boxIndex].scale.set(1.2)
  //   }
  // }
}

function resetUI () {
  createPegsHolder();
  createPegs(config.pegs);
  setupBoxes();
  createBallsPool()
}

export {
  containers,
  createUI,
  uiCreated,
  createBall,
  startMovingBall,
  changeNumberOfLines,
  clearAllBalls,
  setupPayoutText,
  isSetupBoxes,
  boxBounceEffect,
  boolBallCreated,
  totalBalls,
  balls,
  pegs,
  boxes,
  removeLightningMode,
  normalModeUI,
  lightningModeUI,
  gameAssets,
  ballPool,
  pegsForShine,
  totalLines
};

isPixiStandAlone && divButtons();

function divButtons () {
  const createBallDiv = document.createElement("button");
  createBallDiv.innerHTML = "createBall";
  createBallDiv.onclick = () => createBall();
  document.body.appendChild(createBallDiv);

  const boxBounceDiv = document.createElement("button");
  boxBounceDiv.innerHTML = "boxBounce";
  boxBounceDiv.onclick = () =>
    boxBounceEffect(parseInt(prompt("Enter number of boxBounce")));
  document.body.appendChild(boxBounceDiv);

  const linesDiv = document.createElement("button");
  linesDiv.innerHTML = "lines";
  linesDiv.onclick = () =>
    changeNumberOfLines(parseInt(prompt("Enter number of lines")));
  document.body.appendChild(linesDiv);

  const lightningModeDiv = document.createElement("button");
  lightningModeDiv.innerHTML = "lightningMode";
  lightningModeDiv.onclick = () => pixiLightningMode();
  document.body.appendChild(lightningModeDiv);

  const normalModeDiv = document.createElement("button");
  normalModeDiv.innerHTML = "normalMode";
  normalModeDiv.onclick = () => removeLightningMode();
  document.body.appendChild(normalModeDiv);

  const clearAllBallDiv = document.createElement("button");
  clearAllBallDiv.innerHTML = "clearAllBall";
  clearAllBallDiv.onclick = () => clearAllBalls();
  document.body.appendChild(clearAllBallDiv);

  const ballPathOneDiv = document.createElement("button");
  ballPathOneDiv.innerHTML = "ballPathOne";
  ballPathOneDiv.onclick = () => startMovingBall(testPath);
  document.body.appendChild(ballPathOneDiv);

  const ballPathTwoDiv = document.createElement("button");
  ballPathTwoDiv.innerHTML = "ballPathTwo";
  ballPathTwoDiv.onclick = () => startMovingBall(testPath1);
  document.body.appendChild(ballPathTwoDiv);

  const ballPathThreeDiv = document.createElement("button");
  ballPathThreeDiv.innerHTML = "ballPathThree";
  ballPathThreeDiv.onclick = () => startMovingBall(testPath2);
  document.body.appendChild(ballPathThreeDiv);

  const ballPathFourDiv = document.createElement("button");
  ballPathFourDiv.innerHTML = "ballPathFour";
  ballPathFourDiv.onclick = () => startMovingBall(testPath3);
  document.body.appendChild(ballPathFourDiv);
}
